import { FrameData } from '../../types';
import { BeatPulse, SmoothedValue } from '../../utils/audioUtils';
import { hsl } from '../../utils/colorUtils';
import { LayerRenderer } from './LayerRenderer';

export class WaveformRenderer implements LayerRenderer {
  private beatPulse = new BeatPulse(0.94);
  private smoothHue = new SmoothedValue(0.05);

  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const { timeDomainData, bassEnergy, trebleEnergy, isBeat, beatIntensity } = frame;
    const lineWidth = settings.lineWidth ?? 2.5;
    const glowAmount = settings.glowAmount ?? 15;
    const colorHue = settings.colorHue ?? 160;
    const centerY = height / 2;

    this.beatPulse.update(isBeat, beatIntensity);

    const targetHue = colorHue + bassEnergy * 40 - trebleEnergy * 30;
    this.smoothHue.update(targetHue);

    const hue = this.smoothHue.value;
    const lightness = 55 + this.beatPulse.value * 25;
    const color = hsl(hue, 80, lightness);

    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth + this.beatPulse.value * 2;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.shadowColor = color;
    ctx.shadowBlur = glowAmount + this.beatPulse.value * 20;

    ctx.beginPath();

    const step = Math.max(1, Math.floor(timeDomainData.length / width));
    for (let i = 0; i < timeDomainData.length; i += step) {
      const normalized = (timeDomainData[i] - 128) / 128;
      const x = (i / timeDomainData.length) * width;
      const y = centerY + normalized * (height * 0.4);

      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }
    ctx.stroke();
    ctx.shadowBlur = 0;
  }

  resize(): void {}
  destroy(): void {}
}
